import { URL } from '../../config'
import { getRequest, postRequest } from '../../utils/functions/httpRequest'
import { types } from './'

const eventURL = URL.event

export function transferFunds(event) {
    return (dispatch,getState) =>
	{
        const url = `${eventURL}/transferfunds`
        const userToken = getState().oidc.user.access_token
        postRequest(url,event,userToken).then(resp => {
            dispatch(transferFundsSuccess(resp.data))
        })
    }
}

export function transferFundsSuccess(event) {
	return {
		type: types.Event.TRANSFER_FUNDS,
		payload:event
	}
}

export function transferringFunds()
{
	return {
		type: types.Event.TRANSFERRING_FUNDS
	}
}

export function adjustFunds(event) {
    return (dispatch,getState) =>
	{
        const url = `${eventURL}/fundsadjustment`
        const userToken = getState().oidc.user.access_token
        postRequest(url,event,userToken).then(resp => {
            dispatch(adjustFundsSuccess(resp.data))
        })
    }
}

export function adjustFundsSuccess(event) {
	return {
		type: types.Event.ADJUST_FUNDS,
		payload:event
	}
}

export function adjustingFunds()
{
	return {
		type: types.Event.ADJUSTING_FUNDS
	}
}

export function fetchingEventDirectorEvents()
{
	return {
		type: types.Event.FETCHING_EVENT_DIRECTOR_EVENTS
	}
}

export function fetchEventDirectorEvents(seasonId, searchBy, searchValue){
	return (dispatch, getState) =>
	{
		const url = `${eventURL}/searchbydirector/${seasonId}/${searchBy}/${searchValue}`
		const userToken = getState().oidc.user.access_token
		getRequest(url,'json',userToken).then(resp => {
			dispatch(fetchEventDirectorEventsSuccess(resp.data))
		})
	}
}

export function fetchEventDirectorEventsSuccess(event) {
	return {
		type: types.Event.FETCH_EVENT_DIRECTOR_EVENTS,
		payload:event
	}
}


// WEBPACK FOOTER //
// ./src/redux/actions/action_managefunds.js